import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Recruitment } from '../../../class/recruitment';
import { Requisition } from '../../../class/requisition';
import { RecruitmentService } from '../../../service/recruitment/recruitment.service';
import { TranslateService } from '@ngx-translate/core';
import { Message, SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { RequisitionService } from '../../../service/requisition/requisition.service';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { CandidateCommentService } from '../../../service/candidate-comment/candidate-comment.service';

@Component({
  selector: 'app-new-recruitment',
  templateUrl: './new-recruitment.component.html',
  styleUrls: ['./new-recruitment.component.scss']
})
export class NewRecruitmentComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Recruitment;
    @Input() idRequisition: string;
    @Input() idCandidate: number;

    messages: Message[] = [];

    public promiseForm: Promise<any>;
    public form: FormGroup;
    public requisitions: Recruitment[];
    public requisition: Requisition;
    public candidate_id: AbstractControl;
    public management: AbstractControl;
    public managementOptions: SelectItem[];
    public selectedManagement: {label: string, value: string};
    public source: AbstractControl;
    public sourceOptions: SelectItem[];
    public selectedSource: {label: string, value: string};
    public recruited: AbstractControl;
    public es: any;
    public modViewDialog: boolean;
    public new_candidate_id: any;
    public employeePositionToLoadSelection: string;
    public modConfirmationDialog: boolean;
    public show_venue: string = '';
    public show_company: string = '';
    public show_profile_survey: string = '';
    public show_observation: string = '';
    public showPage: boolean = false;
    public modViewSpeechTextDialog: boolean;
    public exclusion: boolean | undefined;
    public confirmation: boolean;

    constructor(
        fb: FormBuilder,
        public recruitmentService: RecruitmentService,
        public translate: TranslateService,
        private notificationsService: NotificationsService,
        public requisitionService: RequisitionService,
        public candidateCommentService: CandidateCommentService) {
        this.requisitions = [];
        
        this.modViewDialog = false;
        this.modConfirmationDialog = false;
        this.employeePositionToLoadSelection = '5,6,21,38';
        this.exclusion = undefined;
        this.confirmation = false;
        this.managementOptions = [
            {label: 'Citado', value: 'Citado'},
            {label: 'Citado Para Contratación', value: 'Citado Para Contratación'},
            {label: 'Citado Para Empresa Usuaria', value: 'Citado Para Empresa Usuaria'},
            {label: 'Citado Para Examen Médico', value: 'Citado Para Examen Médico'},
            {label: 'Pendiente Por Citar', value: 'Pendiente Por Citar'},
            {label: 'Reclutamiento Nocturno', value: 'Reclutamiento Nocturno'},
            {label: 'No Contesta', value: 'No Contesta'},
            {label: 'No Le Interesa Por Distancia', value: 'No Le Interesa Por Distancia'},
            {label: 'No Le Interesa Por Horarios', value: 'No Le Interesa Por Horarios'},
            {label: 'No Le Interesa Por Salario', value: 'No Le Interesa Por Salario'},
            {label: 'No le interesa por condiciones laborales', value: 'No le interesa por condiciones laborales'},
            {label: 'Numero Apagado', value: 'Numero Apagado'},
            {label: 'Numero Equivocado', value: 'Numero Equivocado'},
            {label: 'Numero Fuera de Servicio', value: 'Numero Fuera de Servicio'},
            {label: 'Se Deja Mensaje Con Familiar/Amigo', value: 'Se Deja Mensaje Con Familiar/Amigo'},
            {label: 'Se Deja Mensaje De Voz', value: 'Se Deja Mensaje De Voz'},
            {label: 'Se Deja Razon', value: 'Se Deja Razon'},
            {label: 'Se Encuentra En Proceso', value: 'Se Encuentra En Proceso'},
            {label: 'Se Encuentra Estudiando', value: 'Se Encuentra Estudiando'},
            {label: 'Se Encuentra Laborando', value: 'Se Encuentra Laborando'},
            {label: 'Se Encuentra Viajando', value: 'Se Encuentra Viajando'},
            {label: 'Ya Realizo Proceso Con La Misma EU', value: 'Ya Realizo Proceso Con La Misma EU'},
            {label: 'No Cumple Con El Perfil', value: 'No Cumple Con El Perfil'},
            {label: 'Otro', value: 'Otro'},
        ];

        this.sourceOptions = [
            {label: 'Volanteo', value: 'Volanteo'},
            {label: 'Portal de candidatos', value: 'Portal de candidatos'},
            {label: 'Bolsa de Trabajo de la Universidad', value: 'Bolsa de Trabajo de la Universidad'},
            {label: 'Mercado Natural', value: 'Mercado Natural'},
            {label: 'Computrabajo', value: 'Computrabajo'},
            {label: 'El Empleo', value: 'El Empleo'},
            {label: 'Cliente', value: 'Cliente'},
            {label: 'Familiares o Amigos', value: 'Familiares o Amigos'},
            {label: 'Ferias', value: 'Ferias'},
            {label: 'Periódico o Revistas', value: 'Periódico o Revistas'},
            {label: 'Reclutador externo', value: 'Reclutador externo'},
            {label: 'Redes Sociales', value: 'Redes Sociales'},
            {label: 'SENA', value: 'SENA'},
            {label: 'Alentti', value: 'Alentti'},
            {label: 'Vincuventas', value: 'Vincuventas'},
            {label: 'LinkedIn ', value: 'LinkedIn '},
            {label: 'Cajas de compensación', value: 'Cajas de compensación'},
            {label: 'Indeed', value: 'Indeed'},
            {label: 'Hoy Trabajas', value: 'Hoy Trabajas'},
            {label: 'Trabajos Diarios', value: 'Trabajos Diarios'},
            {label: 'Talentu', value: 'Talentu'},
            {label: 'empleosdeleje.com', value: 'empleosdeleje.com'},
            {label: 'Aplicación desde portal candidatos', value: 'Aplicación desde portal candidatos'},
            {label: 'Otro', value: 'Otro'},
        ];
        this.form = fb.group({
            'candidate_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            'recruited': ['', Validators.compose([Validators.minLength(1)])],
            'source': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            'management': ['', Validators.compose([Validators.required, Validators.minLength(1)])],

        });
        this.candidate_id = this.form.controls['candidate_id'];
        this.recruited = this.form.controls['recruited'];
        this.source = this.form.controls['source'];
        this.management = this.form.controls['management'];
    }

    ngOnInit() {
        // this.getRequisitions(this.idRequisition);
        this.getRequisition(this.idRequisition);
        if(this.edit)
        {
            if (this.edit.source != '' || this.edit.source != null)
            {
                this.form.get('source').clearValidators();
                this.form.get('source').updateValueAndValidity();
                this.form.controls['source'].disable();
            }
        }
    }

    public cancelRecruitment () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
      this.validationCandidate(values);
    }

    public newRecruitment(values) {

        let recruited;
        let recruited_accepted;
        recruited = 1;
        recruited_accepted = 0;


        const param = {
            'requisition_id': Number(this.idRequisition),
            'candidate_id': values.candidate_id.id,
            // 'venue_id': values.venue_id.id,
            // 'company_id': values.company_id.id,
            // 'profile_survey_id': values.profile_survey_id.id,
            'salary': this.requisition.profile_survey_small.salary,
            'person_arl': this.requisition.profile_survey_small.risk,
            'first_day_instruction': this.requisition.customer_guide_small.first_day_instruction,
            'source': values.source.value,
            'management': values.management.value,
            'recruited': recruited,
            'recruited_accepted': recruited_accepted,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.recruitmentService.updateRecruitment(this.edit.id, param)
                :
                this.recruitmentService.newRecruitment(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        this.close.emit(true);
                        this.form.reset();
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    // public getRequisitions(query?: string, filtersReceived?: any[]) {
    //     const filters = [];
    //     if (filtersReceived) {
    //         filtersReceived.forEach(element => {
    //             if (element.value) {
    //                 filters.push({'key': element.key, 'value': element.value});
    //             }
    //         });
    //     }

    //     this.requisitionService.getRequisition(1, 1, undefined, query, filters).toPromise().then(
    //         response => {
    //             this.requisitions = response.json().data;
    //             this.venue_id.setValue(this.requisitions[0].venue);
    //             this.profile_survey_id.setValue(this.requisitions[0].profile_survey);
    //             this.company_id.setValue(this.requisitions[0].company);
    //         },
    //         error => {
    //             // this.msgs = [];
    //             // this.msgs.push( { severity: 'error', summary: 'error' } );
    //         }
    //     );
    // }
    public getRequisition(query?: string, filtersReceived?: any[]) {
        const filters = [];
        if (filtersReceived) {
            filtersReceived.forEach(element => {
                if (element.value) {
                    filters.push({'key': element.key, 'value': element.value});
                }
            });
        }
        var _with = 'profile_survey_small,customer_guide_small,venue,company';
        this.requisitionService.infoRequisition(Number(query),_with).toPromise().then(
            response => {
                this.requisition = response.json();
                this.show_venue = this.requisition.venue.name;
                this.show_company = this.requisition.company.name;
                this.show_observation = this.requisition.observation;
                this.show_profile_survey = this.requisition.profile_survey_small.employee_position;
                this.showPage = true;
            },
            error => {
                // this.msgs = [];
                // this.msgs.push( { severity: 'error', summary: 'error get requisition' } );
            }
        );
    }
    public isNumberSalary(salary_input: any) {
        var salary_output = '0';
        var noValido = /\s/;

        if(salary_input != null && salary_input != '') {
            if(!noValido.test(salary_input)) {
                if(!isNaN(salary_input))
                    salary_output = salary_input;
            }
        }

        return salary_output;
    }

    public gotoProfileSurvey() {
        let profile_survey_id = this.requisition.profile_survey_small.id;
        window.open('/pages/selection/profile-surveis/' + profile_survey_id + '?token=' + localStorage.getItem('token'));
        return (false);
    }

    public showNewCandidateDialog() {
        this.modViewDialog = true;
    }

    public showResultNewCandidate(msg) {
        this.messages = [];
        this.messages.push(msg);
    }

    public cancelNewCandidate() {
        this.modViewDialog = false;
    }

    public getNewCandidate(candidate) {
        console.log (candidate);
        this.modViewDialog = false;
        if (candidate) {
            if (candidate.id) {
                this.new_candidate_id = candidate.id;
                this.candidate_id.setValue(candidate);
            }
        }
    }

    // public formatDate(date) {
    //     const d = new Date(date);
    //     let month = '' + (d.getMonth() + 1);
    //     let day = '' + d.getDate();
    //     const year = d.getFullYear();
    //     let hours = '' + d.getHours();
    //     let minutes = '' + d.getMinutes();
    //     let seconds = '' + d.getSeconds();

    //     if (month.length < 2) {
    //         month = '0' + month;
    //     }
    //     if (day.length < 2) {
    //         day = '0' + day;
    //     }

    //     if (hours.length < 2) {
    //         hours = '0' + hours;
    //     }

    //     if (minutes.length < 2) {
    //         minutes = '0' + minutes;
    //     }

    //     if (seconds.length < 2) {
    //         seconds = '0' + seconds;
    //     }

    //     return [year, month, day].join('-');
    // }

    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }

    public checkOtherValidation (values) {
      let check = false;
      if (values) {
          if (values.candidate_id) {
              if (values.candidate_id.id) {
                  check = true;
              } else {
                  return false;
              }
          } if (this.idCandidate) {
              check = true;
          }
      }
      return check;
  }

  public showSpeechTextDialog() {
    this.modViewSpeechTextDialog = true;
  }

  public validationCandidate(values) {
    let candidate_id = this.form.get('candidate_id').value.id;
    this.candidateCommentService.validationCandidateId(candidate_id).toPromise().then(
      (response) => {
        let responseCandidate = response.json();
        this.exclusion = responseCandidate.result;
        if (this.exclusion == true) {
          this.modConfirmationDialog = true;
        } else {
          this.modConfirmationDialog = false;
          this.newRecruitment(values);
        }
      },
      (error) => {
        console.log(error);
      }
    )
  }

  public confirmationNewRecruitment() {
    this.confirmation = true;
    const values = this.form.value;
    this.newRecruitment(values);
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/recruitment/new-recruitment/new-recruitment.component.ts